import {
    getNotificationEmail,
    updateNotificationEmail
} from "./api";
import { NotificationEmail } from "../../../domain/user/notification/NotificationEmail";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { orderErrorToast, orderSuccessToast } from "../../../app/funcs/orderResultToast";

export const ActionType = Object.freeze({
    base: "@@Monitoring/Action/User",
    getMail: "getMail",
    updateMail: "updateMail"
});

export const getNotificationEmailAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.getMail}`,
    async (_, { rejectWithValue }) => {
        const response = await getNotificationEmail();

        if (response.error === undefined) {
            // API処理結果正常の場合
            return { ...response };
        } else {
            // API処理結果異常の場合
            return rejectWithValue({});
        }
    }
);

export const updateNotificationEmailAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.updateMail}`,
    async(notifications: NotificationEmail[], { rejectWithValue }) => {
        const response = await updateNotificationEmail(notifications);

        if (response.error === undefined) {
            // API処理結果正常の場合
            orderSuccessToast("通知先情報を更新しました");
            return {};
        } else {
            // API処理結果異常の場合
            orderErrorToast("通知先情報の更新に失敗しました");
            return rejectWithValue({});
        }
    }
);
